import {makeAutoObservable, observable} from 'mobx';

import {User} from '@/domain/models/User';
import {UserDetailed} from '@/domain/models/UserDetailed';
import {isUserDetailedModel} from '@/shared/lib/guards/isUserDetailedModel';
import {withStableAvatars} from '@/shared/lib/stabilizeAvatars';

class PeopleStore {
  private _users = observable.map<number, User | UserDetailed>(
    {},
    {deep: false}
  );

  constructor() {
    makeAutoObservable(this);
  }

  getUser(id?: number) {
    return id ? this._users.get(id) : undefined;
  }

  getUserDetailed(id?: number) {
    if (!id) {
      return undefined;
    }
    const user = this._users.get(id);
    return isUserDetailedModel(user) ? user : undefined;
  }

  addOrUpdateUser(user: User | UserDetailed) {
    this._users.set(user.id, withStableAvatars(user, this._users.get(user.id)));
  }

  addOrUpdateUsers(users: User[]) {
    this._users.merge(
      users.map((user) => [
        user.id,
        withStableAvatars(user, this._users.get(user.id)),
      ])
    );
  }

  setUserOnline(userId: number, discoveryActualAt: number) {
    const user = this._users.get(userId);
    if (!user) {
      return;
    }

    this._users.set(user.id, {
      ...user,
      discovery_actual_at: discoveryActualAt,
    });
  }
}

export const peopleStore = new PeopleStore();
